/* eslint-disable */

import axios from 'axios';
import env from '../config/env';
import store from '../store/store';
const BASE_URL = env.apiUrl;

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: false,
  params: {}, // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function(config) {
    /* token retrived from - global window Store */
    // const { token } = Store.state
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.common['Authorization'] = 'Bearer ' + token;
      config.headers.common['Accept'] = 'application/json';
    } else {
      // Use application/x-www-form-urlencoded for login
      config.headers.common['Content-Type'] =
        'application/x-www-form-urlencoded';
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => response,
  error => {
    // Redirects to login page when the token expires
    if (!error || !error.response) {
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      const path = window.location.pathname || '';
      if (!path.startsWith('/login')) {
        window.location.href = '/login';
      }
    } else if (error.response.status == 422) {
      console.log('this.$store---------------------');
      console.log(store);
      store.dispatch('setErrorMessages', error.response.data);
    }
    return Promise.reject(error);
  },
);

export default {
  get(action, params = {}) {
    return instance.get(action, params);
  },
  post(action, data) {
    return instance.post(action, data);
  },
  put(action, data) {
    return instance.put(action, data);
  },
  patch(action, data) {
    return instance.patch(action, data);
  },
  delete(action, data) {
    return instance.delete(action, data);
  },
};
